/* eslint-disable no-unused-vars */
/**
 * @description Class containing the initial configuration style select
 * @author ConfigInitTable?
 * @version 1.0.0
 */
'use strict';
// Modules
import { GroupTypeBase, Styles, Theme } from 'react-select'
import * as CSS from 'csstype'

// Others
import { InitConfigColor } from '../../utils/colors'
import { CSSObject } from 'styled-components';
import { useCallback } from 'react';
const Colors = InitConfigColor.getColors()

// Declare type
export declare type TDefaultSelectStyle = {
    container?: {
        styles?: CSSObject
        mediaPhone?: boolean
        mediaTable?: boolean
        width?: CSS.Property.Width
        margin?: CSS.Property.Margin
        display?: CSS.Property.Display
        widthPhone?: CSS.Property.Width
        widthTable?: CSS.Property.Width
        minWidth?: CSS.Property.MinWidth
        maxWidth?: CSS.Property.MaxWidth
        position?: CSS.Property.Position
        maxWidthTable?: CSS.Property.MaxWidth
        maxWidthPhone?: CSS.Property.MaxWidth
        flexDirection?: CSS.Property.FlexDirection
        hoverDisplayTooltip?: CSS.Property.Display
    }
    label?: {
        styles?: CSSObject
        activeTitle?: boolean
        color?: CSS.Property.Color
        margin?: CSS.Property.Margin
        border?: CSS.Property.Border
        padding?: CSS.Property.Padding
        colorError?: CSS.Property.Color
        fontSize?: CSS.Property.FontSize
        overflow?: CSS.Property.Overflow
        colorDisabled?: CSS.Property.Color
        colorNotValue?: CSS.Property.Color
        textAlign?: CSS.Property.TextAlign
        fontFamily?: CSS.Property.FontFamily
        whiteSpace?: CSS.Property.WhiteSpace
        textOverflow?: CSS.Property.TextOverflow
        hoverDisplayTooltip?: CSS.Property.Display
    }
    select?: {
        activeTitle?: boolean
        styles?: Partial<Styles<{ label: string; value: string; }, boolean, GroupTypeBase<{ label: string; value: string; }>>> | undefined
    }
    tooltip?: {
        styles?: CSSObject
        top?: CSS.Property.Top
        left?: CSS.Property.Left
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        border?: CSS.Property.Border
        bottom?: CSS.Property.Bottom
        padding?: CSS.Property.Padding
        display?: CSS.Property.Display
        fontSize?: CSS.Property.FontSize
        position?: CSS.Property.Position
        topAfterBefore?: CSS.Property.Top
        boxShadow?: CSS.Property.BoxShadow
        leftAfterBefore?: CSS.Property.Left
        backgroundColor?: CSS.Property.Color
        fontFamily?: CSS.Property.FontFamily
        borderAfterBefore?: CSS.Property.Border
        bottomAfterBefore?: CSS.Property.Bottom
        borderRadius?: CSS.Property.BorderRadius
        contentAfterBefore?: CSS.Property.Content
        positionAfterBefore?: CSS.Property.Position
        pointerEventsAfterBefore?: CSS.Property.PointerEvents
    }
    messageError?: {
        required?: string
    }
    loading?: {
        container?: Node
        size?: string | number
        top?: CSS.Property.Top
        left?: CSS.Property.Left
        right?: CSS.Property.Right
        color?: CSS.Property.Color
        bottom?: CSS.Property.Bottom
        position?: CSS.Property.Position
    }
    theme: Theme
    tooltipSelect?: {
        styles?: CSSObject
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        opacity?: CSS.Property.Opacity
        padding?: CSS.Property.Padding
        fontSize?: CSS.Property.FontSize
        maxWidth?: CSS.Property.MaxWidth
        position?: CSS.Property.Position
        overflow?: CSS.Property.Overflow
        maxHeight?: CSS.Property.MaxHeight
        fontFamily?: CSS.Property.FontFamily
        backgroundColor?: CSS.Property.Color
        visibility?: CSS.Property.Visibility
        whiteSpace?: CSS.Property.WhiteSpace
        borderRadius?: CSS.Property.BorderRadius
        textOverflow?: CSS.Property.TextOverflow
    }
    tooltipLabel?: {
        styles?: CSSObject
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        opacity?: CSS.Property.Opacity
        padding?: CSS.Property.Padding
        fontSize?: CSS.Property.FontSize
        maxWidth?: CSS.Property.MaxWidth
        position?: CSS.Property.Position
        overflow?: CSS.Property.Overflow
        maxHeight?: CSS.Property.MaxHeight
        fontFamily?: CSS.Property.FontFamily
        backgroundColor?: CSS.Property.Color
        visibility?: CSS.Property.Visibility
        whiteSpace?: CSS.Property.WhiteSpace
        borderRadius?: CSS.Property.BorderRadius
        textOverflow?: CSS.Property.TextOverflow
    }
    boxSelect?: {
        styles?: CSSObject
    }
}

export let defaultStyle: TDefaultSelectStyle = {
    container: {
        width: '100%',
        display: 'flex',
        widthPhone: '100%',
        widthTable: '100%',
        position: 'relative',
        maxWidthTable: '768px',
        maxWidthPhone: '375px',
        flexDirection: 'column',
        hoverDisplayTooltip: 'block'
    },
    label: {
        border: 'none',
        margin: '1px 0',
        fontSize: '13px',
        activeTitle: true,
        textAlign: 'start',
        overflow: 'hidden',
        padding: '5.2px 0px',
        whiteSpace: 'nowrap',
        fontFamily: 'sans-serif',
        textOverflow: 'ellipsis',
        color: Colors.select?.label,
        hoverDisplayTooltip: 'block',
        colorError: Colors.select?.labelError,
        colorNotValue: Colors.select?.labelLight,
        colorDisabled: Colors.select?.labelHight,
    },
    select: {
        activeTitle: true
    },
    tooltip: {
        left: '0px',
        zIndex: 10,
        bottom: '-35%',
        display: 'none',
        fontSize: '11px',
        borderRadius: '2px',
        padding: '2px 10px',
        position: 'absolute',
        topAfterBefore: '100%',
        leftAfterBefore: '85%',
        fontFamily: 'sans-serif',
        positionAfterBefore: 'absolute',
        pointerEventsAfterBefore: 'none',
        color: Colors.select?.tooltipColor,
        borderAfterBefore: 'solid transparent',
        border: `1px solid ${Colors.select?.tooltipBorder}`,
        backgroundColor: Colors.select?.tooltipBackgroundColor,
        boxShadow: `0px 0px 3px 1px ${Colors.select?.tooltipColorBoxShadow}`,
    },
    messageError: {
        required: 'Campo requerido.'
    },
    loading: {
        color: Colors.loading?.color
    },
    theme: {
        colors: {
            danger: String(Colors.select?.danger),
            primary: String(Colors.select?.primary),
            primary75: `${Colors.select?.primary}BA`,
            primary50: `${Colors.select?.primary}80`,
            primary25: `${Colors.select?.primary}40`,
            neutral10: String(Colors.select?.neutral10),
            neutral20: String(Colors.select?.neutral20),
            neutral30: String(Colors.select?.neutral30),
            neutral40: String(Colors.select?.neutral40),
            neutral50: String(Colors.select?.neutral50),
            neutral60: String(Colors.select?.neutral60),
            neutral70: String(Colors.select?.neutral70),
            neutral80: String(Colors.select?.neutral80),
            neutral90: String(Colors.select?.neutral90),
            dangerLight: String(Colors.select?.dangerLight),
            neutral0: String(Colors.select?.selectBackgroundColor),
            neutral5: String(Colors.select?.selectBackgroundColorDisabled),
        },
        borderRadius: 4,
        spacing: {
            baseUnit: 3.5,
            controlHeight: 2,
            menuGutter: 3
        }
    },
    tooltipSelect: {
        zIndex: 1,
        opacity: '0',
        padding: '5px',
        color: '#fff',
        maxWidth: '150px',
        fontSize: '10px',
        position: 'fixed',
        maxHeight: '80px',
        borderRadius: '4px',
        visibility: 'hidden',
        fontFamily: 'sans-serif',
        backgroundColor: '#00000099',
    },
    tooltipLabel: {
        zIndex: 1,
        opacity: '0',
        padding: '5px',
        color: '#fff',
        maxWidth: '150px',
        fontSize: '10px',
        position: 'fixed',
        maxHeight: '80px',
        borderRadius: '4px',
        visibility: 'hidden',
        fontFamily: 'sans-serif',
        backgroundColor: '#00000099',
    }
}

// Config init select
export const useInitConfigSelect = (): [TDefaultSelectStyle, (newStyles: TDefaultSelectStyle) => void] => {

    const configSelectStyles = useCallback((newStyles: TDefaultSelectStyle) => {
        defaultStyle = {
            container: {
                ...defaultStyle.container,
                ...(newStyles?.container || {})
            },
            label: {
                ...defaultStyle.label,
                ...(newStyles?.label || {})
            },
            tooltip: {
                ...defaultStyle.tooltip,
                ...(newStyles?.tooltip || {})
            },
            select: {
                ...defaultStyle.select,
                ...(newStyles?.select || {})
            },
            messageError: {
                ...defaultStyle.messageError,
                ...(newStyles?.messageError || {})
            },
            loading: {
                ...defaultStyle.loading,
                ...(newStyles?.loading || {})
            },
            theme: {
                ...defaultStyle.theme,
                ...(newStyles?.theme || {})
            },
            tooltipLabel: {
                ...defaultStyle.tooltipLabel,
                ...(newStyles?.tooltipLabel || {})
            },
            tooltipSelect: {
                ...defaultStyle.tooltipSelect,
                ...(newStyles?.tooltipSelect || {})
            },
            boxSelect: {
                ...defaultStyle.boxSelect,
                ...(newStyles?.boxSelect || {})
            }
        }
    }, [])

    return [defaultStyle, configSelectStyles]
}